import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';

import { BULK_WRITES_REDUCER_KEY, type BulkWrite, type BulkWritesStore } from './bulkWritesTypes';

// The store is optional because setRoot swaps the whole root state for a serialized dump, and any
// dump captured before this slice existed has no entry for it.
export const getBulkWritesStore = (
  state: Partial<Pick<RootState, BULK_WRITES_REDUCER_KEY>>,
): BulkWritesStore | undefined => state[BULK_WRITES_REDUCER_KEY];

export const getPendingBulkWrites = createSelector(getBulkWritesStore, (store): BulkWrite[] =>
  Object.values(store?.operations ?? {}),
);
